/* eslint-disable react/prop-types */

import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { HiArrowLeft } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { fetchCommonFilters } from '../../../../../api/reports';
import { Button, Input, Select } from '../../../../../common/components';
import { apiErrorHandler } from '../../../../../utils/handlers';

const PayOffFilter = ({ setShowTable, showTable, onSearchClick, isTableGenerated, searchText }) => {
  const _filterData = useSelector((state) => state.filters.dashboardMultiSelectFilters);
  const [fieldValues, setFieldValues] = useState({
    purchaserOpi: '',
    purchaserName: '',
    contractId: '',
    location: '',
  });
  const [locations, setLocations] = useState([]);
  const [isComponentRendered, setIsComponentRendered] = useState(false);

  useEffect(() => {
    if (isComponentRendered && isTableGenerated) {
      return handleSearch();
    }
    setIsComponentRendered(true);
  }, [isTableGenerated, isComponentRendered]);
  const handleSearch = () => {
    onSearchClick(
      {
        page: 1,
        limit: 5,
        locationId: fieldValues?.location?.value || '',
        purchaserName: fieldValues?.purchaserName || '',
        contractNumber: fieldValues?.contractId || '',
        purchaserOPI: fieldValues?.purchaserOpi || '',
        timezone: moment.tz.guess(),
        ...(searchText ? { opiOrName: searchText || '' } : ''),
      },
      'filterSearch',
    );
  };

  const handleFieldValueChange = (field, value) => {
    setFieldValues({ ...fieldValues, [field]: value });
  };
  const fetchLocations = async () => {
    try {
      const res = await fetchCommonFilters({ type: 'entity' });
      // Entity Processing
      const entities = [
        ...res.data.data.locations.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        }),
      ];

      setLocations(entities);
    } catch (err) {
      apiErrorHandler(err);
    }
  };
  useEffect(() => {
    fetchLocations();
  }, []);

  return (
    <div className="pay-off-new">
      <div className="pay-off-heading">
        <div onClick={() => setShowTable({ ...showTable, show: false })} className="d-inline-block">
          <HiArrowLeft />
        </div>
        <h3 className="d-inline-block">Pay Off Report</h3>
      </div>
      <Row>
        <Col lg={4} className="pay-off-col-inp">
          <Input
            name="segmentValue"
            className="pay-off-input"
            placeholder="Purchaser OPI"
            label="Purchaser OPI"
            value={fieldValues?.purchaserOpi}
            onChange={(e) => handleFieldValueChange('purchaserOpi', e?.target?.value)}
          />
        </Col>
        <Col lg={4} className="pay-off-col-inp">
          <Input
            name="segmentValue"
            className="pay-off-input"
            placeholder="Purchaser Name"
            label="Purchaser Name"
            value={fieldValues?.purchaserName}
            onChange={(e) => handleFieldValueChange('purchaserName', e?.target?.value)}
          />
        </Col>
        <Col lg={4} className="pay-off-col-inp">
          <Input
            name="segmentValue"
            className="pay-off-input"
            placeholder="Contract ID"
            label="Contract ID"
            value={fieldValues?.contractId}
            onChange={(e) => handleFieldValueChange('contractId', e?.target?.value)}
          />
        </Col>
        <Col lg={4} className="pay-off-col-inp">
          <Select
            formInput={false}
            classNamePrefix="select-dropdown"
            placeholder="Location"
            label="Select Location"
            size="lg"
            value={fieldValues?.location}
            onChange={(val) => {
              handleFieldValueChange('location', val);
            }}
            options={locations}
          />
        </Col>
        <Col className="mt-auto">
          <Button onClick={handleSearch} color="primary" className="pay-off-btn">
            Search
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PayOffFilter;
